import { Icon } from '@keen.io/icons';
import { colors } from '@keen.io/colors';
import React from 'react';
import { InteractionLegendWrapper } from './chart-interaction-legend.styles';
import { MousePositionedTooltip } from '@keen.io/ui-core';
import { BodyText } from '@keen.io/typography';
var chartInteractionTooltip = function (text) { return (React.createElement(BodyText, { variant: "body3", fontWeight: "normal" }, text)); };
var ChartInteractionLegend = function () { return (React.createElement(InteractionLegendWrapper, null,
    React.createElement(MousePositionedTooltip, { isActive: true, tooltipPinPlacement: "top-left", tooltipTheme: "light", renderContent: function () {
            return chartInteractionTooltip('Drag and drop to move the map.');
        } },
        React.createElement(Icon, { type: "move", fill: colors.black[500], width: 11, height: 11 })),
    React.createElement(MousePositionedTooltip, { isActive: true, tooltipPinPlacement: "top-left", tooltipTheme: "light", renderContent: function () {
            return chartInteractionTooltip('Scroll to zoom-in or zoom-out.');
        } },
        React.createElement(Icon, { type: "zoom", fill: colors.black[500], width: 11, height: 11 })))); };
export default ChartInteractionLegend;
